<template>
    <div class="lvshi_add" v-loading="loading">
        <el-dialog title="入驻律师" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="titles">欢迎执业律师和非执业律师入驻！请您选择身份：</div>
                <div class="check_type_flex">
                    <div class="checks" :class="{'check_ac':type_ac==item.type}" v-for="(item,index) in type_list" :key="index" @click="handle_type_ac(item)">
                        <div class="imgs">
                            <img src="../../assets/img/index/home/ls_type_nac.png" alt="" v-if="type_ac!=item.type">
                            <img src="../../assets/img/index/home/ls_type_ac.png" alt="" v-if="type_ac==item.type">
                        </div>
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_title2">{{ item.text_ts }}</div>
                    </div>
                </div>
                <div class="btn_flex">
                    <div class="bnts" @click="handle_end">确定</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            type_ac:1,
            type_list:[
                {
                    title:'执照律师',
                    text_ts:'执业律师（持律师实习证或律师执业证）',
                    type:1,
                    
                },
                {
                    title:'非执照律师',
                    text_ts:'（仅持法律从业资格证）',
                    type:2,  
                },
            ], 
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        handle_type_ac(item){
            this.type_ac=item.type
        },
        handle_end(){
            this.dialogVisible=false
            // this.$emit('handle_end')
            this.$router.push({
                path:'/lawyer_add',
                query:{
                    types:this.type_ac
                }
            })
        },
        handle_open(){
            this.dialogVisible=true
        }



    },

}
</script>
<style scoped lang="less">
.lvshi_add {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    padding: 0 40px;
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                    }
                    .check_type_flex{
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        padding-top: 32px;
                        .checks{
                            // flex: 1;
                            width: 220px;

                            cursor: pointer;
                            .imgs{
                                width: 158px;
                                height: 138px;
                                background: #FFFFFF;
                                border-radius: 6px 6px 6px 6px;
                                border: 1px solid #B8C4D1;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin: auto;
                                img{
                                    width: 80px;
                                    height: 80px;
                                }
                            }
                            .check_title{
                                padding-top: 20px;
                                text-align: center;                      
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #888888;

                            }
                            .check_title2{
                                text-align: center;                      
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #888888;
                                padding-top: 5px;
                            }
                        }
                        .check_ac{
                            .imgs{
                                border: 4px solid #377CFD;
                                border-color: #377CFD;
                            }
                            .check_title{
                                color:#377CFD ;
                                font-weight: bold;
                            }
                            .check_title2{
                                color:#377CFD ;
                            }
                        }
                    }
                     
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 48px;
                        .bnts{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
    }
}
</style>